// extracted by mini-css-extract-plugin
export var fullGrid = "_26-3";
export var pdpPreviewContainer = "_26-1";
export var previewContainer = "_26-0";
export var togglePreviewContainer = "_26-2";